import axios from 'axios'

import { Balance, Recharges } from '../model/balance.model'

import { getToken } from '~/net'

export interface FetchRechargesProps {
  subscriptionId: string
  brand: string
  sub: string
  startDate?: string
  endDate?: string
}

export interface FetchBalanceProps {
  subscriptionId: string
  provinceId: string
  brand: string
  sub: string
}

export class BalanceService {
  constructor(private apiGateway: string) {}

  fetchRecharges(fetchRechargesProps: FetchRechargesProps): Promise<Recharges> {
    const { subscriptionId, brand, sub, startDate, endDate } = fetchRechargesProps

    return getToken()
      .then((token) => {
        let authHeaders = {}

        if (token?.access_token !== 'NO_TOKEN_MOCK') {
          authHeaders = { authorization: `Bearer ${token?.access_token}` }
        }

        return axios.get<Recharges>(
          `${this.apiGateway}/customers/v7/orgs/${brand}/subscriptions/${subscriptionId}/recharges`,
          {
            params: {
              startDate,
              endDate,
            },
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'cache-control': 'no-cache',
              'x-sfid': sub,
              ...authHeaders,
            },
          },
        )
      })
      .then((resp) => resp.data)
  }

  fetchBalance(fetchBalanceProps: FetchBalanceProps): Promise<Balance> {
    const { subscriptionId, provinceId, brand, sub } = fetchBalanceProps

    return getToken()
      .then((token) => {
        let authHeaders = {}

        if (token?.access_token !== 'NO_TOKEN_MOCK') {
          authHeaders = { authorization: `Bearer ${token?.access_token}` }
        }

        return axios.get<Balance>(
          `${this.apiGateway}/customers/v7/orgs/${brand}/subscriptions/${subscriptionId}/balance`,
          {
            params: {
              provinceId,
            },
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'cache-control': 'no-cache',
              'x-sfid': sub,
              ...authHeaders,
            },
          },
        )
      })
      .then((resp) => resp.data)
  }
}
